module.exports = __webpack_public_path__ + "media/images/SELLogo-ecd91f64cf5f390c0adc45759acdeab3.png";